var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticClass:"rounded-lg",attrs:{"width":"100%","height":"315","src":_vm.video}})
}
var staticRenderFns = []

export { render, staticRenderFns }